import { EndCustomer } from '../../types'

const endCustomers: EndCustomer[] = [
	{
		id: 10,
		reseller_id: 9,
		name: 'Balloon Supplies Child',
		address1: '25 Barn Door',
		address2: 'Leighs',
		postcode: 'LE97BD',
		description:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi tincidunt, velit vel suscipit ultrices, leo eros dapibus erat, non dictum enim turpis non turpis.'
	},
	{
		id: 11,
		reseller_id: 10,
		name: 'Acme Ltd',
		address1: 'fcgac hcvhyv',
		address2: 'csvhvdhvsh ubu',
		postcode: 'PE26QR',
		description:
			'Quisque finibus laoreet tortor at elementum. Nunc tristique ligula a dui sagittis tincidunt. Vivamus velit nulla, vulputate ac efficitur id'
	},
	{
		id: 12,
		reseller_id: 10,
		name: 'Company Inc.',
		address1: 'cvyavd cayu vuy v',
		address2: 'cvya dvcyvyc vay',
		postcode: 'UB56SH',
		description:
			'Aenean orci arcu, malesuada eu malesuada eget, imperdiet in risus. Nulla facilisi. Sed sed quam facilisis, commodo mauris vel, aliquam eros'
	}
]

export default endCustomers
